export default __webpack_public_path__ + "static/media/348.e74c6801.gif";